// 处理结构结构数据 用于展示
export function preDataProcessShow(formTemplate) {
    if (formTemplate instanceof Array) {
        formTemplate.forEach(item => {
            const {
                formTemplateStructDataList
            } = item;
            if (formTemplateStructDataList instanceof Array) {
                formTemplateStructDataList.forEach(field => {
                    switch (field.structType) {
                        // 处理测距仪类型
                        case 'di':
                            field.value = field.computationProcess;
                            break;
                        // 处理表格数据
                        case 'b':
                            field.tableRowDataMap = field.tableRowDataMap || {};
                            if (Object.keys(field.tableRowDataMap).length === 0) {
                                field.tableRowDataMap['1'] = field.childStructDatas.map(row => {
                                    const newRow = {
                                        dataId: '',
                                        row: 1,
                                        unit: '',
                                        isMust: row.isMust,
                                        structId: row.id,
                                        structType: row.structType,
                                        value: row.structType === 'm' ? [] : ''
                                    };
                                    return newRow;
                                });
                            }
                            field.tableRowDataMap = produceTableData(field.tableRowDataMap);
                            break;
                        // 处理口径数据
                        case 'k':
                            field.caliberDataList = handleCaliberData(field.caliberDataList);
                            break;
                        default:
                            break;
                    }
                });
            }
        });
    }
    return formTemplate;
}
// 生成&处理 表格数据
export function produceTableData(data) {
    const tableData = [];
    if (data instanceof Object) {
        const dataKeys = Object.keys(data);
        dataKeys.forEach((item, index) => {
            let rowInfo = {};
            data[item].forEach(rowItem => {
                let rowInfoTemp = {};
                // 具体处理每列的数据结构
                switch (rowItem.structType) {
                    case 'm':
                        const isStr = rowItem.value && typeof rowItem.value === 'string';
                        rowInfoTemp = {
                            [rowItem.structId]: {
                                isMust: rowItem.isMust,
                                value: isStr ? rowItem.value.split(',') : [],
                                dataId: rowItem.dataId,
                                type: rowItem.structType
                            }
                        };
                        break;
                    case 'di':
                        // const isStr = rowItem.value && typeof rowItem.value === 'string';
                        rowInfoTemp = {
                            [rowItem.structId]: {
                                isMust: rowItem.isMust,
                                value: rowItem.computationProcess,
                                dataId: rowItem.dataId,
                                type: rowItem.structType
                            }
                        };
                        break;
                    case 'n':
                        rowInfoTemp = {
                            [rowItem.structId]: {
                                isMust: rowItem.isMust,
                                value: rowItem.value ? Number(rowItem.value) : '',
                                dataId: rowItem.dataId,
                                type: rowItem.structType
                            }
                        };
                        break;
                    default:
                        rowInfoTemp = {
                            [rowItem.structId]: {
                                isMust: rowItem.isMust,
                                value: rowItem.value,
                                dataId: rowItem.dataId,
                                type: rowItem.structType
                            }
                        };
                        break;
                }
                rowInfo = Object.assign(rowInfo, rowInfoTemp);
            });
            rowInfo.row = item;
            tableData.push(rowInfo);
        });
    }
    return tableData;
}
// 处理 口径数据
export function handleCaliberData(data) {
    let projectKey = 1;
    const caliberData = [];
    if (data instanceof Array && data.length > 0) {
        data.forEach((item, index) => {
            const model = {
                caliberItemId: '',
                caliberTypeList: [], // 口径类型
                caliberProList: [], // 口径项目数据
                caliberSpecificationList: [], // 口径规格
                structType: 'k',
                caliberSpecificationId: '',
                caliberTypeId: '',
                changedPrice: 0,
                createTime: null,
                createUser: null,
                delFlag: null,
                householdId: null,
                id: '',
                newnessRate: 100,
                process: '',
                projectId: null,
                remark: '',
                templateParentStructId: '',
                totalAmount: 0,
                updateTime: null,
                updateUser: null,
                version: 0,
                workAmount: 0
            };
            for (let key of Object.keys(model)) {
                if (item[key]) {
                    model[key] = item[key];
                }
            }
            model.key = projectKey++;
            // item.equalStr = '=';
            // item.rowKey = index;
            caliberData.push(model);
        });
    } else {
        const model = {
            caliberItemId: '',

            caliberTypeList: [], // 口径类型
            caliberProList: [], // 口径项目数据
            caliberSpecificationList: [], // 口径规格
            caliberSpecificationId: '',
            caliberTypeId: '',
            changedPrice: 0,
            createTime: null,
            structType: 'k',
            createUser: null,
            delFlag: null,
            householdId: null,
            id: '',
            newnessRate: 100,
            process: '',
            projectId: null,
            remark: '',
            templateParentStructId: '',
            totalAmount: 0,
            updateTime: null,
            updateUser: null,
            version: 0,
            workAmount: 0
        };
        model.key = projectKey++;
        caliberData.push(model);
    }
    return caliberData;
}


// WEBPACK FOOTER //
// ./src/untils/preDataProcess.js